import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { AggregatedUserWidget } from '@markant-platform/widgets/model';
import { AppConfigService } from '@markant-platform/shared/data-access';

@Injectable({ providedIn: 'root' })
export class WidgetsService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly baseUrl = AppConfigService.appConfiguration?.apiUrl['userWidgets'];

  getVisibleWidgets(): Observable<AggregatedUserWidget[]> {
    return this.http.get<AggregatedUserWidget[]>(`${this.baseUrl}/details?visible=true`);
  }
}
